import React from "react";
import { Fragment, useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/solid";
import {
  ArrowRightOnRectangleIcon,
  BellIcon,
  ChevronLeftIcon,
  Cog8ToothIcon,
  UserCircleIcon,
} from "@heroicons/react/24/solid";
import loginLogo from "../../assets/images/ConfieIQLogo09042023.svg";
import { Popover, Tab } from "@headlessui/react";
import { useRecoilState, useRecoilValue } from "recoil";
import { NavBarItems } from "./NavBarItems";
import { accountAtom, defaultAccount } from "../Login/atoms/AccountAtom";
import { permissionsSelector } from "../Login/selectors/permissionSelector";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { mainSelectedTab } from "../CarrierAgreementMgmt/atoms";
import { OfficeTabs } from "../OfficeTab/OfficeTabs";
import { ReportsTabs } from "../ReportsTab/ReportsTab";
import { VendorTabs } from "../VendorTab/VendorTab";
import { CarrierAgreementMgmtTabs } from "../CarrierAgreementMgmt/carrierAgreementTabs";
import { EmployeeTabs } from "../EmployeeTab/EmployeeTab";
import {
  selectedModule,
  selectedReportIndex,
  selectedReports,
} from "../CarrierAgreementMgmt/ReportsDynamic/DynamicReports/atoms";
const userNavigation = [{ name: "Sign out", path: "/" }];
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const NavBar = () => {
  const [userAccount, setAccount] = useRecoilState(accountAtom);
  const permSelector = useRecoilValue(permissionsSelector);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const history = useHistory();
  const [hover, setHover] = useState();
  const userPermissions = useRecoilValue(permissionsSelector);
  const currentTabs = NavBarItems.filter((tabs) =>
    userPermissions.includes(tabs.permission)
  );
  const { pathname } = useLocation();
  const [, setRecordIdFromRecent] = useState([]);

  let allowedRoutes = [];
  const [, setSelectedReportIndex] = useRecoilState(selectedReportIndex);
  const [, setSelectedReport] = useRecoilState(selectedReports);
  const [, setModuleName] = useRecoilState(selectedModule);
  const [, setTabsIndex] = useRecoilState(mainSelectedTab);

  //User type
  const isMexico = userAccount.isMexico;
  const isFranchise = userAccount.isFranchise;
  const isConfie = userAccount.isNonFranchise;

  const superUserMexico = isMexico && isFranchise && isConfie;
  const superUser = !isMexico && isFranchise && isConfie;
  const franchiseMexico = isMexico && isFranchise && !isConfie;
  const confieMexico = isMexico && !isFranchise && isConfie;

  const roleName = userAccount.roleName
    ? userAccount.roleName
    : "Unspecified Role";

  function Logout() {
    removeCookie("emailAddress", "token");
    localStorage.clear();
    setAccount(defaultAccount);
    history.push("/");
    window.location.reload();
  }
  let location = useLocation();

  const getIndex = () => {
    if (location.state != null) {
      setRecordIdFromRecent(location.state);
    }
    // For dashboard cards selected main tab
    if (location.pathname?.includes("officesettings")) {
      location.state = { officeKey: "officeKey" };
    } else if (location.pathname?.includes("employeetab")) {
      location.state = { employeeKey: "employeesKey" };
    } else if (location.pathname?.includes("vendortab")) {
      location.state = { vendorKey: "vendorKey" };
    } else if (location.pathname?.includes("reportstab")) {
      location.state = { reportsKey: "reportsKey" };
    } else if (
      location.pathname?.toLowerCase()?.includes("carrieragreementmgmt")
    ) {
      location.state = { carrierKey: "CarrierAgreementMgmtKey" };
    } else if (location.pathname?.toLowerCase()?.includes("utilitiestabs")) {
      location.state = { utilKey: "utilitiesKey" };
    }

    const index = NavBarItems.findIndex(
      (x) => x.path.toLowerCase() === pathname.toLowerCase()
    );
    const officeIndex = NavBarItems.findIndex(
      (x) => x.key === location.state?.officeKey
    );
    const reportsIndex = NavBarItems.findIndex(
      (x) => x.key === location.state?.reportsKey
    );
    const carrierIndex = NavBarItems.findIndex(
      (x) => x.key === location.state?.carrierKey
    );
    const employeeIndex = NavBarItems.findIndex(
      (x) => x.key === location.state?.employeeKey
    );
    const vendorIndex = NavBarItems.findIndex(
      (x) => x.key === location.state?.vendorKey
    );
    const utilities = NavBarItems.findIndex(
      (x) => x.key === location.state?.utilKey
    );

    return index === -1
      ? officeIndex === 2
        ? officeIndex
        : reportsIndex === 5
        ? reportsIndex
        : carrierIndex === 1
        ? carrierIndex
        : employeeIndex === 3
        ? employeeIndex
        : vendorIndex === 4
        ? vendorIndex
        : utilities
      : index;
  };

  const [selectedIndex, setSelectedIndex] = useState(getIndex);

  useEffect(() => {
    if (pathname?.toLowerCase()?.includes("home")) {
      const homeIndex = NavBarItems.findIndex((x) => x.key === "homeKey");
      setSelectedIndex(homeIndex);
    } else if (pathname?.toLowerCase()?.includes("carrieragreementmgmt")) {
      const carrierIndex = NavBarItems.findIndex(
        (x) => x.key === "CarrierAgreementMgmtKey"
      );
      const carrierTabIndex = CarrierAgreementMgmtTabs?.findIndex((x) =>
        x.to?.toLowerCase()?.includes(pathname?.toLowerCase())
      );
      setSelectedIndex(carrierIndex);
      setTabsIndex(carrierTabIndex);
    } else if (pathname?.toLowerCase()?.includes("officesettings")) {
      const officeIndex = NavBarItems.findIndex((x) => x.key === "officeKey");
      const officeTabIndex = OfficeTabs.findIndex((x) =>
        x.to?.toLowerCase()?.includes(pathname?.toLowerCase())
      );
      setSelectedIndex(officeIndex);
      setTabsIndex(officeTabIndex);
    } else if (pathname?.toLowerCase()?.includes("employeetab")) {
      const employeesIndex = NavBarItems.findIndex(
        (x) => x.key === "employeesKey"
      );
      const employeesTabIndex = EmployeeTabs.findIndex((x) =>
        x.to?.toLowerCase()?.includes(pathname?.toLowerCase())
      );
      setSelectedIndex(employeesIndex);
      setTabsIndex(employeesTabIndex);
    } else if (pathname?.toLowerCase()?.includes("vendortab")) {
      const vendorKey = NavBarItems.findIndex((x) => x.key === "vendorKey");
      const vendorTabsIndex = VendorTabs.findIndex((x) =>
        x.to?.toLowerCase()?.includes(pathname?.toLowerCase())
      );
      setSelectedIndex(vendorKey);
      setTabsIndex(vendorTabsIndex);
    } else if (pathname?.toLowerCase()?.includes("utilitiestabs")) {
      const utilitiesIndex = NavBarItems.findIndex(
        (x) => x.key === "utilitiesKey"
      );
      setSelectedIndex(utilitiesIndex);
    } else if (pathname?.toLowerCase()?.includes("notifications")) {
      const notificationIndex = NavBarItems.findIndex(
        (x) => x.key === "notificationsfeekey"
      );
      setSelectedIndex(notificationIndex);
    }
  }, [pathname]);

  const userTypeMappings = [
    { condition: superUser, label: "Super User" },
    { condition: superUserMexico, label: "Super User (Mexico)" },
    { condition: franchiseMexico, label: "Franchise (Mexico)" },
    { condition: confieMexico, label: "Confie (Mexico)" },
    { condition: isMexico, label: "Mexico" },
    { condition: isFranchise, label: "Franchise" },
    { condition: isConfie, label: "Confie" },
  ];
  const userType = userTypeMappings.find((x) => x.condition)?.label || "";

  return (
    <Disclosure as="nav" className="">
      {({ open }) => (
        <>
          <div key={0} className=" mx-auto ml- px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className=" sm:justify-start md:w-auto">
                <div className="flex-shrink-0 pr-2">
                  <Link
                    as="div"
                    key="homekey"
                    to="/home"
                    className={classNames("")}
                  >
                    <img
                      className="h-16 w-36 object-contain"
                      src={loginLogo}
                      alt="Confie"
                    />
                  </Link>
                </div>
              </div>
              <div className="flex justify-end  md:w-full w-auto h-6">
                <div className="">
                  <div className="flex items-center px-4">
                    <Tab.Group
                      // defaultIndex={defaultTab}
                      selectedIndex={selectedIndex}
                      onChange={setSelectedIndex}
                    >
                      <Tab.List
                        className={`max-w-full`}
                        style={{
                          gridTemplateColumns: `repeat(${currentTabs?.length}, minmax(0, 1fr)`,
                        }}
                      >
                        {NavBarItems?.map((navItem, index) => {
                          const urlPath = {
                            pathname: navItem.path,
                          };
                          return (
                            //   permSelector?.filter((perms) =>
                            //   NavBarItems[0]?.permission?.includes(perms)
                            // ).length > 0
                            (index === 0 ||
                              permSelector?.includes(navItem.permission)) &&
                              !navItem.withSub &&
                              navItem.label !== "NOTIFICATIONS" ? (
                              <Tab
                                key={index}
                                onClick={() => {
                                  setSelectedReportIndex(0);
                                  setSelectedIndex(index);
                                  setSelectedReport("");
                                  setModuleName("");
                                  history.push(urlPath);
                                }}
                              >
                                {({ selected }) => (
                                  <div className="w-full">
                                    {/* {JSON.stringify(selected)} */}

                                    <div
                                      style={{
                                        zIndex:
                                          index === selectedIndex
                                            ? currentTabs?.length + 1
                                            : hover === index
                                            ? currentTabs?.length + 2
                                            : currentTabs?.length - index &&
                                              currentTabs?.length,
                                      }}
                                      onMouseEnter={() => setHover(index)}
                                      onMouseLeave={() => setHover(undefined)}
                                      className={`inline-block whitespace-nowrap sm:px-4 md:px-6 lg:px-6 py-3 font-medium 
                                              sm:text-xs3 lg:text-sm cursor-pointer tracking wide relative rounded-t-2xl
                                              w-full
                                           
                                             ${
                                               index !== 0 //default tab color
                                                 ? index === hover
                                                   ? "tab-leftLightNavbar" //last tab
                                                   : "tab-leftLightNavbar tab-rightLightNavbar" //[0] first color of tab
                                                 : "tab-rightLightNavbar" //first tab
                                             }
                                              ${
                                                index === selectedIndex
                                                  ? "min-w-max bg-tabColor text-white font-bold text-secondary tab-rightSelectedMainCurve tab-leftSelectedMainCurve" //for selected tab
                                                  : "bg-tabBgColor  hover:min-w-max hover:bg-tabColor hover:text-white  text-primary tab-rightMainCurve tab-leftMainCurve hover:tab-rightSelectedMainCurve hover:tab-leftSelectedMainCurve"
                                              } 
                                             
                                              ${
                                                //curve for selected tab
                                                index === selectedIndex
                                                  ? " tab-rightSelectedMainCurve" //if first tab is selected
                                                  : index === selectedIndex
                                                  ? "tab-leftSelectedMainCurve" //if last tab is selected
                                                  : index === selectedIndex &&
                                                    index !== 0 &&
                                                    index !== selectedIndex - 1
                                                  ? "tab-rightSelectedMainCurve tab-leftSelectedMainCurve" //default tabs
                                                  : ""
                                              }   
                                      `}
                                    >
                                      <div className="truncate maintabs-text-size">
                                        {navItem.label}
                                      </div>
                                    </div>
                                  </div>
                                  // {/* {navItem.iconComponent}
                                  // <div>{navItem.label}</div> */}
                                )}
                              </Tab>
                            ) : (
                              permSelector.includes(navItem.permission) && (
                                <Menu as="div" key={index} className="relative">
                                  <div>
                                    <Menu.Button className="px-6 py-5 text-xs font-medium rounded-t-2xl nav-link bg-tabBgColor hover:bg-secondary hover:text-white gap-x-2">
                                      {/* User icon */}

                                      <Cog8ToothIcon className="h-4 w-4" />
                                      <div>
                                        {navItem.label} {navItem.sub[index]}
                                      </div>
                                    </Menu.Button>
                                  </div>
                                  <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                  >
                                    <Menu.Items className="origin-top-right z-50 px-2 absolute right-0 mt-2 w-48 rounded-md box-shadow py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                      {navItem.sub
                                        .filter((c) => c.children.length === 0)
                                        .map((item, index) =>
                                          permSelector.includes(
                                            item.permission
                                          ) ? (
                                            <Menu.Item key={index}>
                                              <NavLink
                                                key={index}
                                                to={item.path}
                                                activeStyle={{
                                                  fontWeight: "bold",
                                                  color: "#cb227b ",
                                                }}
                                                className={classNames(
                                                  item.current
                                                    ? "text-gray-900 border-b-2 bg-blue-200 "
                                                    : "text-gray-900 rounded-md ",
                                                  " py-3.5 text-xs3 font-medium nav-link  "
                                                )}
                                              >
                                                {item.icon}
                                                {item.label}
                                              </NavLink>
                                            </Menu.Item>
                                          ) : null
                                        )}

                                      {navItem.sub
                                        .filter((c) => c.children.length > 0)
                                        .map(
                                          (item, index) =>
                                            permSelector.includes(
                                              item.permission
                                            ) && (
                                              <Popover
                                                key={index}
                                                className="relative"
                                              >
                                                <Popover.Button className=" py-3 text-xs font-medium nav-link gap-x-2">
                                                  <ChevronLeftIcon className="h-4 w-4 float-left ml-4 mr-2 mt-0.5" />
                                                  <div> {item.label}</div>
                                                </Popover.Button>
                                                <Popover.Panel className="absolute right-full top-1/3  -ml-20  w-64 rounded-md box-shadow py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                  {item.children.map(
                                                    (it, index) => {
                                                      return (
                                                        permSelector.includes(
                                                          it?.permission
                                                        ) && (
                                                          <Menu.Item
                                                            key={index}
                                                          >
                                                            <Link
                                                              key={index}
                                                              to={it.path}
                                                              className={classNames(
                                                                item.current
                                                                  ? "text-gray-900 border-b-2 bg-blue-200 "
                                                                  : "text-gray-900 rounded-md ",
                                                                " py-3.5 text-xs3 font-medium nav-link  "
                                                              )}
                                                            >
                                                              {it.icon}
                                                              {it.label}
                                                            </Link>
                                                          </Menu.Item>
                                                        )
                                                      );
                                                    }
                                                  )}
                                                </Popover.Panel>
                                              </Popover>
                                            )
                                        )}
                                    </Menu.Items>
                                  </Transition>
                                </Menu>
                              )
                            )
                          );
                        })}
                      </Tab.List>
                    </Tab.Group>
                  </div>
                </div>

                <div className="">
                  <div className="flex items-center mt-4 md:mr-20 md:ml-6 h-1 w-1">
                    {/* Profile dropdown */}
                    <Menu as="div" className="relative">
                      {({ open }) => (
                        <>
                          <Menu.Button
                            className={`px-8 py-2 font-medium mt-2 
                                      cursor-pointer rounded-t-3xl w-full
                                      hover:min-w-max hover:bg-tabColor hover:text-white text-primary
                                      hover:tab-rightMainCurve hover:tab-leftMainCurve
                                      group
                                      focus:tab-rightSelectedMainCurve focus:tab-leftSelectedMainCurve 
                                      ${
                                        open |
                                        (location.pathname === "/notifications")
                                          ? "bg-tabColor text-white tab-rightSelectedMainCurve tab-leftSelectedMainCurve"
                                          : ""
                                      }`}
                          >
                            <UserCircleIcon
                              className={`h-8 w-8 ${
                                open | (location.pathname === "/notifications")
                                  ? "text-white"
                                  : "text-gray-500"
                              } group-hover:text-white`}
                              aria-hidden="true"
                            />
                          </Menu.Button>

                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="origin-top-left z-20 top-7/12 absolute -right-2 w-64 rounded-md bg-[#0B77BF]">
                              <div className="flex justify-items-start py-2">
                                <div className="self-center ml-2">
                                  <UserCircleIcon className="text-white h-8 w-8" />
                                </div>
                                <div className="ml-2 self-center text-white">
                                  <div className="italic text-sm font-semibold">
                                    {userAccount.firstName +
                                      " " +
                                      userAccount.lastName}
                                  </div>
                                  {userAccount.isFranchise &&
                                  userAccount.isNonFranchise ? (
                                    <strong className="text-xxs -mt-2 italic">
                                      (
                                      {userAccount.roleName ||
                                        "Unspecified Role"}{" "}
                                      - Super User)
                                    </strong>
                                  ) : userAccount.isFranchise ? (
                                    <strong className="text-xxs -mt-2 italic">
                                      (
                                      {userAccount.roleName ||
                                        "Unspecified Role"}{" "}
                                      - Franchise)
                                    </strong>
                                  ) : (
                                    <strong className="text-xxs -mt-2 italic">
                                      (
                                      {userAccount.roleName ||
                                        "Unspecified Role"}{" "}
                                      - Confie)
                                    </strong>
                                  )}
                                </div>
                              </div>
                              {userAccount?.rolePermissions?.length > 0 && (
                                <>
                                  <hr className="borderPrimary" />
                                  <Menu.Item>
                                    <div
                                      className="flex items-center px-4 py-5 gap-4
                                      block capitalize text-xs w-full font-bold text-quinary bg-white
                                      hover:text-white hover:bg-quinary hover:border-2 border border-[#0B77BF]"
                                    >
                                      <BellIcon className="h-5 w-5" />
                                      <Link key={1} to={"/notifications"}>
                                        Notifications
                                      </Link>
                                    </div>
                                  </Menu.Item>
                                </>
                              )}
                              <hr className="borderPrimary" />
                              <Menu.Item>
                                <div
                                  className="flex items-center px-4 py-5 gap-4
                                  block capitalize text-xs w-full font-bold text-quinary bg-white
                                  hover:text-white hover:bg-quinary hover:border-2 border border-[#0B77BF]"
                                >
                                  <ArrowRightOnRectangleIcon className="h-5 w-5" />
                                  <button onClick={() => Logout()}>
                                    Sign Out
                                  </button>
                                </div>
                              </Menu.Item>
                            </Menu.Items>
                          </Transition>
                        </>
                      )}
                      <div>
                        <Menu.Button className="nav-linkNoText max-w-xs rounded-full flex items-center text-sm">
                          <UserCircleIcon
                            className={`h-8 w-8 ${"text-gray-500 hover:text-quinary"}`}
                            aria-hidden="true"
                          />
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="origin-top-left z-20 top-3/4 absolute right-0 w-48 rounded-md box-shadoww bg-white">
                          <div className="flex justify-items-start py-2">
                            <div className="self-center ml-2">
                              <UserCircleIcon className="text-gray-500 h-8 w-8 " />
                            </div>
                            <div className="ml-2 self-center text-gray-600  ">
                              <div className="  italic text-sm font-semibold">
                                {userAccount.firstName +
                                  " " +
                                  userAccount.lastName}
                              </div>
                              <strong className="text-xxs -mt-2 italic ">
                                ({roleName} {userType && `- ${userType}`})
                              </strong>
                            </div>
                          </div>
                          {userAccount &&
                          userAccount?.rolePermissions &&
                          userAccount?.rolePermissions?.length > 0 ? (
                            <>
                              <hr className="borderPrimary" />
                              <Menu.Item>
                                <div
                                  className="flex items-center px-4 py-5 gap-4
                                  block capitalize text-xs w-full font-bold text-gray-600
                                  hover:text-primary"
                                  to={"/notifications"}
                                >
                                  <BellIcon className="h-5 w-5" />
                                  <Link key={1} to={"/notifications"}>
                                    {"Notifications"}
                                  </Link>
                                </div>
                              </Menu.Item>
                            </>
                          ) : (
                            ""
                          )}
                          <hr className="borderPrimary" />
                          <Menu.Item>
                            <div
                              className="flex items-center px-4 py-5 gap-4
                              block capitalize text-xs w-full font-bold text-gray-600
                              rounded-b hover:rounded-b-lg hover:text-primary"
                            >
                              <ArrowRightOnRectangleIcon className="h-5 w-5" />
                              <button onClick={() => Logout()}>Sign Out</button>
                            </div>
                          </Menu.Item>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
              </div>
              <div className="-mr-2 flex md:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="inline-flex items-center justify-center p-1 rounded-md text-gray-700 hover:text-white hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon
                      key={0}
                      className="block h-6 w-6"
                      aria-hidden="true"
                    />
                  ) : (
                    <Bars3Icon
                      key={1}
                      className="block h-6 w-6"
                      aria-hidden="true"
                    />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>
          {/* Mobile menu view */}
          <Disclosure.Panel className="md:hidden">
            <div className="flex flex-col py-2">
              {allowedRoutes.map((item, index) => {
                return (
                  <Link
                    as="div"
                    key={index}
                    to={item.path}
                    className={classNames(
                      item.current
                        ? "text-gray-900 border-b-2 border-blue-500"
                        : "text-gray-900 hover:bg-primary hover:text-white",
                      "text-sm font-medium w-full px-6 py-2"
                    )}
                  >
                    {item.title}
                  </Link>
                );
              })}
            </div>
            <div className="mx-3 py-3 space-y-2 border-t border-secondary">
              <div className="flex items-center sm:px-2 md:px-4 lg:px-6">
                <div className="flex items-center">
                  <div className="text-sm font-medium leading-none text-quinary">
                    {localStorage.getItem("userName")}
                  </div>
                </div>
                <button type="button" className="text-quinary ml-auto">
                  <span className="sr-only">View notifications</span>
                  <BellIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
              <div className="w-full flex px-6 justify-center items-center">
                <Menu>
                  {userNavigation.map((item, index) => (
                    <Menu.Item key={index} onClick={Logout}>
                      <Link
                        as="div"
                        key={index}
                        to={item.path}
                        className="px-6 py-1 text-sm font-medium border border-secondary rounded-md text-secondary hover:text-white hover:bg-secondary"
                      >
                        {item.name}
                      </Link>
                    </Menu.Item>
                  ))}
                </Menu>
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};
export default NavBar;
